import React, { useState } from 'react';
import { OnboardingWrapper } from '../../../components';
import { Status, useAuthContext, useOnboarding } from '../../../data-access';
import { useNavigate } from 'react-router-dom';
import { Stack } from '@mui/material';

import GoogleIcon from '../../../assets/onboarding/googleIcon.png';
import AppleIcon from '../../../assets/onboarding/apple-logo.png';
import ProductHuntBadge from '../../../assets/onboarding/product_hunt.png';
import testimonialImage from '../../../assets/onboarding/testimonial.png';

import './GetStartedPage.scss';

export const GetStartedPage: React.FC = () => {
  const navigate = useNavigate();
  const { currentOnboardingStep, goToPreviousStep, updateInfoAfterSignUp } = useOnboarding();
  const { signIn, isUserFetching, status } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);

  const isSigningIn = status === Status.SIGNING_IN || isUserFetching || isLoading;

  const handleSignIn = async (provider: 'google' | 'apple') => {
    try {
      setIsLoading(true);
      const newUser = await signIn(provider);
      await updateInfoAfterSignUp(newUser);
      navigate('/', { replace: true });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <OnboardingWrapper
      currentOnboardingStep={currentOnboardingStep}
      onBack={goToPreviousStep}
      title="Join 70,000 people optimizing their day with Lifestack"
      buttons={[
        {
          text: (
            <Stack direction="row" alignItems="center" gap={1.5} justifyContent="center">
              <img
                src={GoogleIcon}
                alt="Google"
                style={{
                  width: 24,
                  height: 24,
                  backgroundColor: 'white',
                  borderRadius: '4px',
                  padding: 4,
                }}
              />
              <span>Continue with Google</span>
            </Stack>
          ),
          onPress: () => handleSignIn('google'),
          disabled: isSigningIn,
          loading: isSigningIn,
          variant: 'contained',
        },
        {
          text: (
            <Stack direction="row" alignItems="center" gap={1.5} justifyContent="center">
              <img
                src={AppleIcon}
                alt="Apple"
                style={{
                  width: 24,
                  height: 24,
                  backgroundColor: 'white',
                  borderRadius: '4px',
                  padding: 4,
                }}
              />
              <span>Continue with Apple</span>
            </Stack>
          ),
          onPress: () => handleSignIn('apple'),
          disabled: isSigningIn,
          loading: isSigningIn,
          variant: 'contained',
        },
      ]}
      contentContainerStyle={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      buttonContainerStyle={{ flexDirection: 'column' }}
    >
      <div className="get-started">
        <img
          src={ProductHuntBadge}
          alt="Product Hunt badge"
          className="get-started__badge"
        />
        <img src={testimonialImage} alt="Testimonial" className="get-started__image" />
      </div>
    </OnboardingWrapper>
  );
};
